import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectTranslations } from '../App/slice/selectors';

interface ReadMoreProps {
  children?: React.ReactNode;
  lines?: number;
  moreText?: string;
  lessText?: string;
  html?: string;
}

const ReadMore: React.FC<ReadMoreProps> = ({
  lines = 3,
  children,
  moreText = 'b2c.txt.viewMore',
  lessText = 'b2c.txt.viewShort',
  html,
}) => {
  const translations = useSelector(selectTranslations);
  const textRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    setShowToggle(el.scrollHeight > el.clientHeight);
  }, [html, children, lines]);

  return (
    <ReadMoreWrapper>
      <ReadMoreText
        ref={textRef}
        className={`read-more-text ${expanded ? 'expanded' : ''}`}
        style={{ WebkitLineClamp: expanded ? 'unset' : lines }}
        {...(html
          ? { dangerouslySetInnerHTML: { __html: html } }
          : { children })}
      />
      {showToggle && (
        <ReadMoreButton onClick={() => setExpanded(!expanded)}>
          {expanded
            ? translations?.[lessText] ?? lessText
            : translations?.[moreText] ?? moreText}
          <i className={`fa fa-chevron-${expanded ? 'up' : 'down'} ms-1`}></i>
        </ReadMoreButton>
      )}
    </ReadMoreWrapper>
  );
};

export default ReadMore;
const ReadMoreWrapper = styled.div``;
const ReadMoreText = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  font-size: 12px;
  color: #444444;
  .expanded {
    display: block;
  }
`;
const ReadMoreButton = styled.button`
  margin-top: 4px;
  padding: 0;
  background: none;
  border: none;
  color: var(--color-9);
  font-size: 12px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
